module.exports = __webpack_public_path__ + "img/hr-V-L-2-load-standup-base.5d76b288.png";